export const STABILITY_FILTER = {
  INCLUDE: 'include',
  ONLY: 'only',
  EXCLUDE: 'exclude',
};

export const STABILITY_FILTER_DEFAULT = STABILITY_FILTER.INCLUDE;

export const STABILITY_FILTER_OPTIONS = [
  { value: STABILITY_FILTER.INCLUDE, label: 'stabilityFilter.include' },
  { value: STABILITY_FILTER.ONLY, label: 'stabilityFilter.only' },
  { value: STABILITY_FILTER.EXCLUDE, label: 'stabilityFilter.exclude' },
];

export const IS_STABILITY_BY_FILTER = {
  [STABILITY_FILTER.ONLY]: true,
  [STABILITY_FILTER.EXCLUDE]: false,
};

export const stabilityFilterFromIsStability = (isStability) => {
  if (isStability === true) return STABILITY_FILTER.ONLY;
  if (isStability === false) return STABILITY_FILTER.EXCLUDE;
  return STABILITY_FILTER_DEFAULT;
};
